import * as React from "react";

import classes from "./ClipNotAllowed.styl";
import {Illustration} from "@ok/common/design-system/components/Illustration";
import {Content, ContentsView} from "@ok/common/design-system/components/Content";
import {l10n} from "@ok/web/modules/l10n/l10n";

const l10NPkg = l10n("clips");

export const ClipNotAllowed: React.FC = (): React.ReactElement => {
    return (
        <div className={classes["clip-not-allowed"]}>
            <Illustration
                src={"/mres/img/stub/2024/ill_blacklist@2x.png"}
                alt={l10NPkg.getLMsg("clipUnavailable")}
                size="112"
            />
            <ContentsView>
                <ContentsView.Row size={"21b"}>
                    <Content alignmentX={"center"}>
                        <Content.Text view={"primary"}>
                            {l10NPkg.getLMsg("clipUnavailable")}
                        </Content.Text>
                    </Content>
                </ContentsView.Row>
            </ContentsView>
            <div className={classes["clip-not-allowed__reason"]}>
                <ContentsView>
                    <ContentsView.Row size={"15"}>
                        <Content alignmentX={"center"}>
                            <Content.Text view={"secondary"} alignmentX={"center"}>
                                {l10NPkg.getLMsg("clipUnavailableReasonDeletedOrHidden")}
                            </Content.Text>
                        </Content>
                    </ContentsView.Row>
                </ContentsView>
            </div>
        </div>
    );
};
